<template>
  <div
    :class="{'hide-label': !property(section.options.content.time, 'displayLabels', true)}"
    :style="{...scale, ...fullMarginSubject(section.options.customize.style)}"
  >
    <div class="image-background" />
    <div
      :style="{...color, ...fullPaddingSubject(section.options.customize.style)}"
      class="time-item-1 position-relative"
    >
      <slot
        name="time"
        v-bind="{shadow, backgroundColor, color: colorCustom('Subtitle'), scale, sizing}"
      />
    </div>
  </div>
</template>

<script>
import TemplateMixin from '../../../../mixins/TemplateMixin'
import ThemeMixin from '../../../../mixins/ThemeMixin'
import PropertiesManager from '../../../../mixins/PropertiesManager'
import _ from 'lodash'
import BorderMixin from '@/components/mixins/BorderMixin'

export default {
  name: 'Carousel1Template',
  mixins: [TemplateMixin, ThemeMixin, PropertiesManager, BorderMixin],
  computed: {
    shadow () {
      const shadow = this.section.options.content.time.shadowOptions
      const color = this.section.options.content.time.shadowColor || '#DADADA'

      if (!shadow) return {}

      return {
        boxShadow: shadow.spread ? `${shadow.offsetX || 0}px ${shadow.offsetY || 0}px ${shadow.blur}px ${shadow.spread || 0}px ${color}` : ''
      }
    },
    scale () {
      return _.get(this.section.options.content.time, [`size${this.tablet ? 'md' : this.resolution}`], this.section.options.content.time.size) || 0.8
    },
    sizing () {
      return this.section.options.content.time.sizing || {
        width: 6,
        counter: 3.5,
        divider: 1.5,
        subtitle: 0.8,
        padding: 3
      }
    }
  }
}
</script>

<style lang="scss">
.time-item-1 {
  .timer-block {
    border-radius: 10px;
    border: 1px solid #d5d5d5;

    .timer-item {
      .time {
        position: relative;
        display: block;
        font-weight: 700;
        font-size: 94px;
        text-align: center;
        line-height: 1;
      }

      .time-divider {
        display: block;
        font-weight: 500;
        font-size: 94px;
        text-align: center;
      }

      .time-divider + .subtitle {
        opacity: 0;
      }

      .subtitle {
        text-align: center;
        font-weight: 700;
        display: block;
        font-size: 16px;
        text-transform: uppercase;
        margin-bottom: 10px;
      }
    }
  }
}

.resolution-sm {
  .time-item-1 {
    .timer-block {
      .timer-item {
        .time {
          font-size: 40px;
          width: auto;
        }

        .time-divider {
          font-size: 30px;
          margin-right: 10px;
          margin-left: 10px;
        }

        .subtitle {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
